import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/toxicologia/informes-sobre-impurezas-orgánicas")({
  beforeLoad: () => { throw redirect({ href: "/es/servicios/toxicologia-regulatoria/informes-sobre-impurezas-org\u00e1nicas", statusCode: 301 }); },
});
